export const REACT_BACKEND_URL = process.env.REACT_APP_BASE_URL;

